export const icons = {
	account: {
		default: 'fa-regular fa-wallet',
	},
	accountYear: {
		default: 'fa-regular fa-calendar-range',
	},
	address: {
		default: 'fa-regular fa-address-book',
	},
	building: {
		default: 'fa-regular fa-building',
		multiple: 'fa-solid fa-buildings',
		house: 'fa-solid fa-house',
	},
	loading: {
		default: 'fas fa-spinner fa-pulse',
	},
	unit: {
		default: 'fa-thin fa-building',
		heating: 'fa-solid fa-heat',
		warm_water: 'fa-solid fa-droplet-degree',
		consumption: 'fa-solid fa-bolt',
		cost: 'fa-solid fa-money-bill',
		emission: 'fa-solid fa-smoke',
		open_door: 'fa-solid fa-door-open',
		calendar: 'fa-solid fa-calendar',
		actions: 'fa-solid fa-list-check',
		group_sort: 'fa-solid fa-object-group',
		view: 'fa-solid fa-map-location-dot',
		map_location: 'fa-solid fa-map-location',
	},
	user: {
		default: 'fa-solid fa-user',
		book_reader: 'fa-solid fa-book-open-reader',
		check: 'fa-solid fa-user-check',
		clock: 'fas fa-alarm-clock',
		check_square: 'fas fa-check-square',
	},
	person: {
		default: 'fa-solid fa-users',
		multiple: 'fa-solid fa-address-book',
		lock: 'fas fa-user-lock',
		lock_type: 'fa-solid fa-lock',
		function: 'fa-solid fa-user-group',
		change_request: 'fa-solid fa-user-pen',
		location_dot: 'fa-solid fa-location-dot',
		birthday_cake: 'fa-solid fa-cake-candles',
		mobile: 'fa-solid fa-mobile',
		fax: 'fa-solid fa-fax',
		briefcase: 'fa-solid fa-briefcase',
		phone: 'fa-solid fa-phone',
		settings: 'fa-solid fa-square-sliders-vertical',
		circle: 'fa-solid fa-circle-user',
		hand_left: 'fa-solid fa-hand-point-left',
		wallet: 'fa-solid fa-wallet',
		weight: 'fa-solid fa-weight-scale',
	},
	document: {
		default: 'fa-solid fa-files',
		multiple: 'fa-solid fa-book',
		book: 'fas fa-book',
		list: 'fa-solid fa-file',
		home: 'fas fa-home',
		folder: 'fas fa-folders',
		file_lines: 'fa-solid fa-file-lines',
		file_invoice: 'fa-solid fa-file-invoice',
		receipt: 'fa-solid fa-receipt',
		folder_open: 'fa-solid fa-folder-open',
	},
	document_check: {
		default: 'fa-solid fa-magnifying-glass-dollar',
	},
	note: {
		type: 'fa-solid fa-note-sticky',
		address: 'fa-solid fa-compass',
		prio_highest: 'fas fa-chvron-double-up',
		prio_low: 'fas fa-chevron-down',
		prio_lowest: 'fas fa-chevron-double-down',
		prio_none: 'fas fa-grip-lines',
		prio_normal: 'fas fa-chevron-up',
		info: 'fa-solid fa-circle-info',
		copy: 'fa-solid fa-copy',
		paste: 'fas fa-paste',
		circle_plus: 'fa-solid fa-circle-plus',
	},
	search: {
		default: 'fa-solid fa-magnifying-glass',
		filter: 'fa-solid fa-filter',
		descending: 'fa-solid fa-arrow-down',
		ascending: 'fa-solid fa-arrow-up',
		list: 'fas fa-ellipsis-v',
		default_plus: 'fa-solid fa-magnifying-glass-plus',
		default_minus: 'fa-solid fa-magnifying-glass-minus',
	},
	error: {
		connection: 'fas fa-exclamation-circle',
		user: 'fas fa-user-slash',
		wifi: 'fas fa-wifi-slash',
		bug: 'fa-solid fa-bug',
		maintenance: 'fas fa-user-hard-hat',
		signature: 'fa-solid fa-file-signature',
		xmark: 'fas fa-times-square',
		404: 'fa-solid fa-ghost',
		triangle_exc: 'fa-solid fa-triangle-exclamation',
	},
	administration: {
		default: 'fa-solid fa-screwdriver-wrench',
		multiple: 'fa-solid fa-users-cog',
		refresh: 'fas fa-sync fa-spin',
		refresh_o: 'fas fa-sync',
		evaluation: 'fa-solid fa-chart-line',
		notification: 'fas fa-bells',
		bell: 'fas fa-bell',
		bell_on: 'fas fa-bell-on',
		no_notification: 'fa-solid fa-bell-slash',
		subscription: 'fa-solid fa-file-pen',
		settings: 'fa-solid fa-cogs',
		general_setting: 'fa-solid fa-pen-paintbrush',
		email_setting: 'fa-solid fa-envelopes-bulk',
		definitions: 'fas fa-clipboard-list',
		user_settings: 'fas fa-user-cog',
		cloud: 'fa-solid fa-cloud-arrow-down',
	},
	email: {
		default: 'fa-solid fa-envelope',
		settings: 'fa-solid fa-mailbox',
		import: 'fa-solid fa-paper-plane',
		templates: 'fa-solid fa-envelope-open-text',
	},
	meter: {
		default: 'fa-regular fa-tachometer-alt',
	},
	team: {
		default: 'fa-solid fa-chalkboard-teacher',
		create: 'fa-solid fa-chalkboard-user',
		info: 'fa-solid fa-square-info',
		add_member: 'fas fa-user-plus',
		assignment: 'fa-solid fa-table-list',
		table_cells: 'fa-solid fa-table-cells-large',
	},
	button_icon: {
		default: 'fas fa-question',
		add: 'fas fa-plus',
		save: 'fas fa-save',
		cancel: 'fa-solid fa-ban',
		close: 'fas fa-window-close',
		minimize: 'fa-solid fa-minimize',
		maximize: 'fa-solid fa-maximize',
		delete: 'fas fa-trash',
		delete_alt: 'fas fa-trash-alt',
		update: 'fas fa-edit',
		open: 'fas fa-eye',
		print: 'fa-solid fa-print',
		logout: 'fa-solid fa-arrow-right-from-bracket',
		reject: 'fa-solid fa-hand',
		release: 'fa-solid fa-check',
		show_all: 'fa-solid fa-files',
		next: 'fa-solid fa-forward-step',
		backward: 'fa-solid fa-backward-step',
		profile_picture: 'fa-solid fa-image-portrait',
		key: 'fa-solid fa-key',
	},
	server: {
		default: 'fas fa-server',
	},
	faq: {
		default: 'fa-solid fa-square-question',
	},
	craftsmanTask: {
		default: 'fa-regular fa-hammer',
		tasks: 'fas fa-tasks-alt',
		calender_check: 'fas fa-calendar-check',
		euro: 'fa-solid fa-euro-sign',
		calendar_range: 'fa-solid fa-calendar-range',
		task: 'fas fa-tasks',
	},
	report: {
		default: 'fa-regular fa-ticket',
	},
	cis: {
		default: 'fa-regular fa-comment-lines',
		reply: 'fa-solid fa-reply',
		comment: 'fa-solid fa-comment',
	},
	sort: {
		default: 'fa-solid fa-sort',
		up: 'fa-solid fa-sort-up',
		down: 'fa-solid fa-sort-down',
	},
	other: {
		module: 'fa-solid fa-toolbox',
		options: 'fa-solid fa-wrench',
		color: 'fa-solid fa-swatchbook',
		logo: 'fa-solid fa-image',
		welcome_text: 'fas fa-handshake',
		welcome_simple: 'fa-solid fa-handshake-simple',
		add_picture: 'fas fa-plus-square',
		damage_report: 'fa-solid fa-house-crack',
		report_time: 'fa-solid fa-alarm-exclamation',
		visibility: 'fa-solid fa-eye-slash',
		resubmission: 'fas fa-clipboard-list-check',
		persons: 'fa-solid fa-rectangle-list',
		no_data: 'fa-solid fa-database',
		x: 'fa-solid fa-xmark',
		x_times: 'fas fa-times',
		highlighter: 'fa-solid fa-highlighter',
		back: 'fa-solid fa-chevron-left',
		forward: 'fa-solid fa-chevron-right',
		terms_of_service: 'fa-solid fa-user-secret',
		terms_of_use: 'fa-solid fa-exclamation',
		link: 'fa-solid fa-link',
		upload_img: 'fa-solid fa-file-arrow-up',
		calendar: 'fa-solid fa-calendar-exclamation',
		calendar_plus: 'fa-solid fa-calendar-plus',
		calendar_minus: 'fa-solid fa-calendar-minus',
		tags: 'fas fa-tags',
		cabinet: 'fas fa-cabinet-filing',
		calendar_day: 'fas fa-calendar-day',
		thumbs_up: 'fa-solid fa-thumbs-up',
		info: 'fas fa-info',
		double_check: 'fa-solid fa-check-double',
		plug: 'fas fa-edit',
		box_dollar: 'fa-solid fa-box-dollar',
		bill_transfer: 'fa-solid fa-money-bill-transfer',
		images: 'fas fa-images',
		pencil: 'fas fa-pencil',
		thumbtack: 'fa-solid fa-thumbtack',
		bars: 'fa-solid fa-bars',
		undo: 'fas fa-undo',
		redo: 'fas fa-redo',
		tally: 'fa-solid fa-tally',
		cross: 'fa-solid fa-up-down-left-right',
		clock: 'fas fa-clock',
		directions: 'fas fa-directions',
		bars_staggered: 'fa-solid fa-bars-staggered',
		smiley: 'fa-solid fa-message-smile',
		right: 'fa-solid fa-right',
		lightbulb: 'fa-solid fa-lightbulb',
		star_half: 'fas fa-star-half',
		greater_equal: 'fa-solid fa-greater-than-equal',
		infinity: 'fa-solid fa-infinity',
		up: 'fa-solid fa-caret-up',
		down: 'fa-solid fa-caret-down',
		minus: 'fa-solid fa-minus',
	},
}

function capitalizeFirstLetter(string: string) {
	return string.charAt(0).toUpperCase() + string.slice(1)
}

function getIconsFlattened() {
	const result = {}
	for (const category in icons) {
		const obj = icons[category]
		for (const iconName in obj) {
			const value = obj[iconName]
			const keyValue = category + capitalizeFirstLetter(iconName)
			result[keyValue] = value
		}
	}
	return result
}

export { icons as default, getIconsFlattened }
